import React from 'react';
import StoreGraphic from '../../../static/images/utils/store-1.svg'
import Badge from "../../Atoms/Badge";

const SubsidiaryItem = props => {
  const {isMain, isSelected} = props
  return (
    <article className={`s-mb-0 s-cross-start nowrap s-px-6px s-py-4px normal-radius hover-change cursor-pointer ${isSelected && 'is-selected'}`}>
      <img
        className="flex-none s-w-32px s-h-32px s-mr-8px"
        src={StoreGraphic}
      />
      <div>
        <div className="s-cross-center nowrap">
          <p className="small s-mb-0 s-mr-8px">Coquitos</p>
          {isMain && (
            <Badge text="Principal" />
          )}
        </div>
        <p className="s-mb-0 smaller s-color-light-text">1901 Thornridge Cir. Shiloh, Hawaii 81063</p>
      </div>
    </article>
  );
};


export default SubsidiaryItem;
